import React from 'react';
import { Badge } from '@shopify/polaris';

/**
 * @param {*} status - This is the status of the purchase order and programs.
 * This comes from the API and is used to determine the status of the purchase order and programs, which will set the text and style of the badge using
 * the out of the box Polaris Badge component and styling.
 * @returns
 */
const CustomBadge = ({ status }) => {
    const getButtonStyle = (status) => {
        switch (status) {
            case 'Audit Required':
            case 'Pending Finance Approval':
            case 'Pending Manager Approval':
            case 'Open':
            case 'Initiated':
                return {
                    text: status,
                    tone: 'attention',
                };

            case 'Exception':
            case 'Archived':
            case 'Inactive':
            case 'Error':
            case 'Rejected':
            case 'Canceled':
                return {
                    text: status,
                    tone: 'critical',
                };

            case 'In Progress':
            case 'Pending':
            case 'Pending Receipt':
            case 'Expired':
                return {
                    text: status,
                    tone: 'warning',
                };

            case 'In Transit':
            case 'Preparing':
                return {
                    progress: 'complete',
                    text: status,
                    tone: 'info',
                };

            case 'Full':
            case 'Partial':
                return {
                    text: status,
                    tone: 'default',
                };

            case 'Receive':
            case 'Closed':
            case 'Draft':
                return {
                    text: status,
                    tone: 'default',
                };

            case 'Received':
            case 'Submitted':
            case 'Completed':
            case 'Complete':
            case 'Active':
                return {
                    text: status,
                    tone: 'success',
                };
            default:
                return {
                    tone: 'default',
                    progress: 'incomplete',
                    text: 'Unknown Status',
                };
        }
    };

    const { tone, text, progress } = getButtonStyle(status);

    if (!status) {
        return null;
    }

    return (
        <Badge tone={tone ?? null} progress={progress ?? null}>
            {text}
        </Badge>
    );
};

export default CustomBadge;
